import { render, staticRenderFns } from "./KaarttypeEdit.vue?vue&type=template&id=b4cb4c3e&scoped=true"
import script from "./KaarttypeEdit.vue?vue&type=script&lang=js"
export * from "./KaarttypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cb4c3e",
  null
  
)

export default component.exports